import classNames from 'classnames'
import React from 'react'

interface ISubNav {
  align: 'left' | 'right' | 'center'
  className?: string
  tabs: {
    value: string
    text: string
  }[]
  tabNow: string
  onClick?: (tab: string) => void
}

export default function SubNav(props: ISubNav) {
  const { align, tabs, className, tabNow, onClick } = props
  return (
    <>
      <div className={classNames(className, 'header')}>
        {tabs.map(({ value, text }, index) => (
          <span
            className={classNames(
              {
                active: tabNow === value,
              },
              'item'
            )}
            onClick={() => {
              if (onClick) {
                onClick(value)
              }
            }}
            key={`${value} ${index}`}
          >
            {text}
          </span>
        ))}
      </div>
      <hr className="split-line" />
      <style jsx>
        {`
          .header {
            display: flex;
            align-items: flex-start;
            justify-content: ${align === 'left'
          ? 'flex-start'
          : align === 'center'
            ? 'center'
            : 'flex-end'};
            height: 37px;
          }
          .item {
            font-family: PingFangSC-Regular;
            font-size: 18px;
            line-height: 25px;
            color: #1f2129;
            letter-spacing: 0;
            font-weight: 400;
            cursor: pointer;
            margin-right: ${align === 'left' || align === 'center'
              ? '40px'
              : '0'};
            margin-left: ${align === 'right' || align === 'center'
                ? '40px'
                : '0'};
          }
          .active {
            font-family: PingFangSC-Medium;
            color: #1a1a1a;
            font-weight: 500;
            position: relative;
          }
          .active::after {
            position: absolute;
            left: 0;
            bottom: -12px;
            content: '';
            height: 4px;
            width: 100%;
            background-color: #ffe100;
          }
          .split-line {
            height: 1px;
            background-color: #f2f4fa;
            border: none;
            margin-top: 0;
          }
        `}
      </style>
    </>
  )
}
